import { ApolloLink, Observable } from '@apollo/client';
import { getOperationAST } from 'graphql';

export function createManagedQueryLink() {
    const link = new ApolloLink((operation, forward) => {
        const { operation: operationType } = getOperationAST(operation.query, null)!;

        if (operationType === 'subscription') {
            return forward(operation);
        } else {
            return new Observable(observer => {
                return forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer),
                });
            });
        }
    });

    return link;
}
